import React from 'react'

const Manual_yappy_qr = () => {
  return (
    <div className="px-4 py-16 mx-auto sm:max-w-xl md:max-w-full lg:max-w-screen-xl md:px-24 lg:px-8 lg:py-10">
      <div className="mt-16">
        <h2 className="font-bold text-4xl text-[#002D33] mb-5">Yappy - Generación de QR</h2>
        <iframe
          src="https://scribehow.com/embed/Yappy__Generacion_de_QR__u-kevq07S9qcd64Jcvr4ow?as=scrollable"
          className="scribe-iframe-general-193"
          width="100%"
          height="2500"
          allowFullScreen
          style={{ border: 0, minHeight: '640px' }}
        ></iframe>
      </div>
    </div>
  )
}

export default Manual_yappy_qr
